import { Circle, Box, createIcon, IconProps } from '@chakra-ui/react';

export type IconComponentType = ReturnType<typeof createIcon>;
export function CircleIconWrapper({
  icon: IconComponent,
  size,
  color = 'white',
  bg = 'black',
  scale = 14 / 22,
  borderRadius,
}: {
  icon: IconComponentType;
  size: string;
  color?: IconProps['color'];
  bg?: IconProps['bg'];
  scale?: number;
  borderRadius?: string;
}) {
  if (borderRadius) {
    return (
      <Box
        width={size}
        height={size}
        bg={bg}
        color={color}
        borderRadius={borderRadius}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <IconComponent boxSize={`${scale * 100}%`} color={color} />
      </Box>
    );
  }
  return (
    <Circle size={size} bg={bg} color={color}>
      <IconComponent boxSize={`${scale * 100}%`} color="white" />
    </Circle>
  );
}
